import BannerAlert from '../general/alert/BannerAlert';
import { SECOND_IN_MILLISECONDS } from '../../lib/util/time/constants';
import { Stack } from '@mui/material';
import { differenceInDays } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { useSubscriptionDetails } from '../../lib/subscription/detail/useSubscriptionDetails';

const DAYS_IN_WEEK = 7;
const SCAN_LIMIT_WARN_THRESHOLD = 0.8;

const SubscriptionBannerAlerts = () => {
    const { subscriptionDetail, getSubscriptionDetailStatus } = useSubscriptionDetails();
    const history = useHistory();

    const showTrialEnding = useMemo(() => {
        const trialEndEpochInSeconds = subscriptionDetail?.trialEnd;
        if (!trialEndEpochInSeconds) {
            return false;
        }
        
        const trialEndDate = new Date(trialEndEpochInSeconds * SECOND_IN_MILLISECONDS);
        const now = new Date();
        return differenceInDays(trialEndDate, now) < DAYS_IN_WEEK && differenceInDays(trialEndDate, now) >= 0;
    }, [subscriptionDetail]);

    const showApproachingScanLimit = useMemo(() => {
        const meteringUsage = subscriptionDetail?.meteringUsage;
        const meteringLimit = subscriptionDetail?.meteringLimit;
        if (meteringUsage && meteringLimit) {
            return meteringUsage >= meteringLimit * SCAN_LIMIT_WARN_THRESHOLD && meteringUsage < meteringLimit;
        }
        return false;
    }, [subscriptionDetail]);

    const showScanLimitReached = useMemo(() => {
        const meteringUsage = subscriptionDetail?.meteringUsage;
        const meteringLimit = subscriptionDetail?.meteringLimit;
        if (meteringUsage && meteringLimit) {
            return meteringUsage >= meteringLimit;
        }
        return false;
    }, [subscriptionDetail]);

    return (
        <>
            {getSubscriptionDetailStatus === 'success' &&
                <>
                    {showTrialEnding && (
                        <BannerAlert
                            message={`Your trial period ends on ${subscriptionDetail?.trialEnd ? new Date(subscriptionDetail?.trialEnd * SECOND_IN_MILLISECONDS).toLocaleDateString() : 'NaN'}. Upgrade now to avoid disruption.`}
                            severity="warning"
                            onClick={() => {
                                history.push('/profile');
                            }}
                        />
                    )}
                    {showApproachingScanLimit && (
                        <BannerAlert
                            message={`You have used ${subscriptionDetail?.meteringUsage} out of ${subscriptionDetail?.meteringLimit} scans for this period. Upgrade now to avoid disruption or overage fees.`}
                            severity="warning"
                            onClick={() => {
                                history.push('/profile');
                            }}
                        />
                    )}
                    {showScanLimitReached && (
                        <BannerAlert
                            message={`You have reached your scan limit of ${subscriptionDetail?.meteringLimit} scans for this period. Upgrade now to avoid disruption or overage fees.`}
                            severity="error"
                            onClick={() => {
                                history.push('/profile');
                            }}
                        />
                    )}
                </>
            }
        </>
    );
};

export default SubscriptionBannerAlerts;